import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-acupoint-list",
  "use": "icon-common-acupoint-list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-common-acupoint-list\">\n<path d=\"M1.5763 11.9805L1.56738 20.1613C1.56738 20.6567 2.02463 21.1305 2.86015 21.1305H5.46863H5.59346H5.70297H5.80869V10.6953H2.86399C2.04886 10.7119 1.5763 11.4914 1.5763 11.9805Z\" fill=\"#409EFF\" />\n<path d=\"M19.815 9.39259L14.598 9.39132C16.6715 2.53384 12.7843 2.87136 12.7843 2.87136C11.3845 2.87136 10.6853 4.06988 10.6853 5.47729C10.6802 5.43527 10.6815 5.47856 10.684 5.49384C10.6089 7.75332 7.80679 10.1861 6.5293 10.6204V21.1308H18.5108C19.9984 21.1308 20.4875 19.8265 20.4875 19.8265C21.3345 17.8026 22.3853 13.1652 22.4095 12.9016C22.7215 9.53649 19.815 9.39259 19.815 9.39259Z\" fill=\"#409EFF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/common-acupoint-list.svg
// module id = M1Cm
// module chunks = 111